import { Action, GeneralReducerInterface } from "types/interface"
import { useReducer } from "react"

export default function useGeneralReducer<S>(initState: S, fn?: GeneralReducerInterface<S>) {
  function reducer(state: S, action: Action): S {
    if (fn) {
      const [flag, data] = fn(state, action)
      if (flag) {
        return data as S
      }
    }
    return Object.assign({}, state, {
      [action.type]: action.value
    })
  }
  
  return useReducer(reducer, initState)
}


